import { Link } from 'gatsby';
import React from 'react';
import Logo from 'svg/logo-with-grafana-labs.inline.svg';

import styles from './header-logo.module.scss';

export const HeaderLogo = () => (
  <Link className={styles.wrapper} to={'/'}>
    <Logo className={styles.logo} />
  </Link>
);
